import React from 'react';
import { SchedulerTypes } from 'devextreme-react/scheduler';

type AppointmentProps = {
  data: { targetedAppointmentData: SchedulerTypes.Appointment; }
};

export const Appointment = (props: AppointmentProps) => {
  const { targetedAppointmentData } = props.data;
  return (
    <div>
      <div>
      {targetedAppointmentData.Completed && (
          <i className='dx-icon-check' />
        )}
        {targetedAppointmentData.Text}
        <span> ({targetedAppointmentData.ActivityName})</span>
      </div>
    </div>
  );
};
